import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Drawer, Row, Col, Tooltip, Modal } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import { getUrlPushWrapper } from '../../../routes'
import { hideLoader, showLoader } from '../../../modules/actions'
import { RightsWrapper } from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane




@Form.create()
class AddEditSuggestion extends React.Component {
  state = {
    visible: true
  }


  onClose = () => {
    this.setState({ visible: false })
    setTimeout(() => {
      this.props.onClose()
    }, 400)
  }


  handleSubmit = (e) => {
    let { form, record } = this.props
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      let values = _.clone(valData)
      let x = null
      if (record && record._id) {
        values._id = record._id
        x = await Request.updateSuggestion(values)
      } else {
        x = await Request.addSuggestion(values)
      }
      if (x.success) {
        notification.success({
          message: x.msg
        })
      } else {
        notification.error({
          message: x.msg
        })
      }
      this.onClose()
    })
  }




  componentDidMount() {
    let { record, form: { setFieldsValue } } = this.props
    if (record && record._id) {
      setTimeout(() => {
        setFieldsValue(record)
      }, 400)
    }
  }

  render() {
    let { visible } = this.state
    let { form: { getFieldDecorator, setFieldsValue }, record } = this.props

    const inputTypes = {
      fields: [
        {
          label: 'Title',
          key: 'title',
          required: true
        },
        {
          label: 'Description',
          key: 'description',
          type: 'textarea',
          required: true
        },
        {
          label: 'Type',
          key: 'suggestionType',
          type: 'select',
          options: [{ id: 'Only Suggestion', display: 'Only Suggestion - Improvements' }, { id: 'Raise Ticket', display: 'Raise Ticket - Bugs' }],
          required: true,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              suggestionType: v,
            });
          },
        },
        {
          label: 'Related To',
          key: 'relatedTo',
          type: 'select',
          options: ["LMS", 'T-Vision', 'T-Connect'],
          onChange: v => {
            this.props.form.setFieldsValue({ relatedTo: v })
          }
        },
        {
          label: "Upload Document",
          key: "document",
          type: "file",
          defaultFileList: [],
        }
      ]
    };
    return (
      <Drawer
        title={(record && record._id ? 'Edit' : 'Add') + " Suggestion/Ticket"}
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={700}
        visible={visible}>
        <Card>
          <Form onSubmit={this.handleSubmit}>
            <GetAllFormFields getFieldDecorator={getFieldDecorator} apiurl={LAPI_URL} inputSchema={inputTypes} />
            <Row style={{ marginTop: '20px' }}>
              <Col span={8} />
              <Col span={8}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginBottom: 10 }}
                  loading={this.props.loading}>
                  Save
                </Button>
              </Col>
              <Col span={8} />
            </Row>
          </Form>
        </Card>

      </Drawer>
    )
  }
}


// @Form.create()
// class ApproveRegularisationRequest extends Component {
//   state = {
//       visible:true,
//       regularisationApproved:null,
//       regularisationDisapprove:true
//   }

//   handleSubmit = e =>{
//       e.preventDefault();
//       const {form, data} = this.props;
//       form.validateFieldsAndScroll(async(err,valData)=>{
//           if(!err) {
//               let values = _.clone(valData);
//               delete data.status
//               _.each(data, (val,key)=>{
//                   values[key] = val
//               })
//               values.userId = data.userId._id
//               values.loginAt = values.startTime
//               values.logoutAt = values.endTime
//               delete values.startTime
//               delete values.endTime
//               let response = await Request.updateRegularisationRequest(values);
//               if(response.success) {
//                   notification.success({
//                       message:response.message
//                   })
//               }else {
//                   notification.error({
//                       message:response.message
//                   })
//               }
//               this.onClose();
//           }
//       })
//   }


//   onClose = () => {
//       setTimeout(() => {
//           this.props.onClose()
//       }, 400)
//   }


//   async componentDidMount(){

//   }

//   render() {
//       const {visible, regularisationApproved, regularisationDisapprove} = this.state
//       const inputTypes = {
//         fields:[
//           {
//             label: 'Status',
//             key: 'suggestionStatus',
//             type: 'select',
//             required: true,
//             options: ["Pending", "In Process", "Under Testing", "Completed"],
//             onChange: v => {
//               this.props.setFieldsValue({ suggestionStatus: v })
//             }
//           }

//         ]
//       }
//       // const inputTypes = {
//       //     fields: [
//       //         {
//       //             label:'Action',
//       //             type:'select',
//       //             required:true,
//       //             key:'status',
//       //             options:["Approved", "Disapproved"],
//       //             onChange:v=>{
//       //                 this.props.form.setFieldsValue({status:v})
//       //                 if(v==="Approved") {
//       //                     this.setState({regularisationApproved:true, regularisationDisapprove:true})
//       //                     this.setFieldsValue()
//       //                 }else if (v==="Disapproved") {
//       //                     this.setState({regularisationApproved:false, regularisationDisapprove:false})
//       //                 }
//       //             }
//       //         },
//       //         {
//       //             label:'Reason',
//       //             type:'text',
//       //             key:'disapproveReason',
//       //             required:!regularisationDisapprove,
//       //             hidden:regularisationDisapprove
//       //         },
//       //         {
//       //             label:'Start Time',
//       //             type:'time',
//       //             key:'startTime',
//       //             required:regularisationApproved,
//       //             hidden:!regularisationApproved
//       //         },
//       //         {
//       //             label:'End Time',
//       //             type:'time',
//       //             key:'endTime',
//       //             required:regularisationApproved,
//       //             hidden:!regularisationApproved,
//       //         }
//       //     ]
//       // }

//       const {
//           form: {getFieldDecorator}
//       } = this.props
//       return (
//           <Drawer 
//           title={
//               <div>
//                   <React.Fragment>
//                       Approve/Disapprove Request
//                   </React.Fragment>
//               </div>
//           }
//               placement="right"
//               closable={true}
//               onClose={this.onClose}
//               width={400}
//               visible={visible}>
//               <Card>
//                   <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
//                       <div>
//                       <GetAllFormFields
//                               apiurl={API_URL}
//                               inputSchema={inputTypes}
//                               getFieldDecorator={getFieldDecorator}
//                           />
//                       </div>
//                       <Row style={{marginTop:'20px'}}>
//                           <Col span={8}/>
//                           <Col span={8}>
//                               <Button
//                                   type="primary"
//                                   htmlType="submit"
//                                   style={{marginBottom: 10}}
//                                   loading={this.props.loading}>
//                                   SAVE
//                               </Button>
//                           </Col>
//                           <Col span={8}/>
//                       </Row>
//                   </Form>
//               </Card>

//           </Drawer>
//       )
//   }
// }

@Form.create()
class UpdateSuggestionStatus extends React.Component {
  state = {
    visible: true
  }


  onClose = () => {
    this.setState({ visible: false })
    setTimeout(() => {
      this.props.onClose()
    }, 400)
  }

  handleSubmit = (e) => {
    let { form, suggestionId } = this.props;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      let values = _.clone(valData)
      values._id = suggestionId;
      let response = await Request.updateSuggestionStatus(values)
      if (response.success) {
        notification.success({
          message: response.msg
        })
      } else {
        notification.error({
          message: response.msg
        })
      }
      this.onClose()
    })
  }




  componentDidMount() {

  }

  render() {
    let { visible } = this.state
    let { form: { getFieldDecorator, setFieldsValue } } = this.props

    const inputTypes = {
      fields: [
        {
          label: 'Status',
          key: 'suggestionStatus',
          type: 'select',
          required: true,
          options: ["Pending", "In Process", "Under Testing", "Completed"],
          onChange: v => {
            setFieldsValue({ suggestionStatus: v })
          }
        }
      ]
    }
    return (
      <Drawer
        title={`Update Suggestion Status`}
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={500}
        visible={visible}>
        <Card>
          <Form onSubmit={this.handleSubmit}>
            <GetAllFormFields getFieldDecorator={getFieldDecorator} apiurl={LAPI_URL} inputSchema={inputTypes} />
            <Row style={{ marginTop: '20px' }}>
              <Col span={8} />
              <Col span={8}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginBottom: 10 }}
                  loading={this.props.loading}>
                  Save
                </Button>
              </Col>
              <Col span={8} />
            </Row>
          </Form>
        </Card>

      </Drawer>
    )
  }
}

@Form.create()
class AllStaffSuggestions extends Component {
  state = {
    id: '',
    total: 0,
    ticketsTotal: 0,
    activeTab: '0',
    refreshChild: false,
    suggestionId: null,
    showUpdateStatusDrawer: false,
    isActive: true,
    users: [],
    showAddSuggestionDrawer: false,
    record: null,
    modalOpen: false
  }


  handleOk = () => {
    this.setState({ modalOpen: false })
  };
  handleCancel = () => {
    this.setState({ modalOpen: false, record: null })
  };

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      let { activeTab } = this.state
      if (!this.state.isActive) {
        params.suggestionStatus = 'Completed'
      }
      if (activeTab === "0") {
        params.suggestionStatus = "Pending"
      } else if (activeTab === "1") {
        params.suggestionStatus = "In Process"
      } else if (activeTab === "2") {
        params.suggestionStatus = "Under Testing"
      } else if (activeTab === "3") {
        params.suggestionStatus = "Completed"
      }
      if (!params.results || params.count) {
        params.results = 50
        params.count = 50
      }
      if (!params.sortField || !params.sortOrder) {
        params.sortField = "createdByUser.time"
        params.sortOrder = "descend"
      }
      let data = await Request.getSuggestion({
        ...params,
        regExFilters: ["suggestionToken", "title", "description", "relatedTo", "suggestionType", 'createdByUser.name']
      })
      let users = []
      if (data.users) {
        _.each(data.users, (user) => {
          users.push({ value: user, text: user })
        })
      }
      this.setState({ total: data.total, users: users })
      resolve(data)
    })
  }

  closeUpdateDrawer = () => {
    this.setState({ showUpdateStatusDrawer: false, suggestionId: null })
    this.reload()
  }

  closeAddSuggestion = () => {
    this.setState({ showAddSuggestionDrawer: false, record: null })
    this.reload()
  }

  onOk = value => {
    this.reload()
  }
  reload = () => {
    this.table.current.reload()
  }

  deleteSuggestion = async data => {
    this.setState({ loading: true })
    await Request.deleteSuggestion(data)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Suggestion Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  updateSuggestionStatusDrawer(suggestionId) {
    if (suggestionId) {
      this.setState({ showUpdateStatusDrawer: true, suggestionId: suggestionId })
    }
  }

  showDescription = (record) => {
    this.setState({ modalOpen: true, record: record })
  }


  setSuggestionData(suggestion) {
    this.setState({ showAddSuggestionDrawer: true, record: suggestion })

  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  componentWillMount() {

  }

  async componentDidMount() {
  }

  showAddSuggestion = () => {
    this.setState({ showAddSuggestionDrawer: true })
  }



  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    }, () => {
      this.table.current.reload()
    })
  }



  render() {
    const { dispatch } = this.props
    const {
      form: { getFieldDecorator, setFieldsValue }
    } = this.props
    const { id, showUpdateStatusDrawer, suggestionId, record, showAddSuggestionDrawer, modalOpen } = this.state;

    const columns = [
      {
        title: 'Date',
        key: 'createdByUser.time',
        dataIndex: 'createdByUser.time',
        sorter: true,
        render: (text, record) => {
          return (
            <div>
              {/* <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div> */}
              <div>{record.createdByUser ? moment(record.createdByUser.time).format('DD-MM-YYYY') : record.createdByUser ? moment(record.createdByUser.time).format('DD-MM-YYYY') : ''}</div>
            </div>
          )
        }
      },
      {
        title: 'Days',
        key: 'days',
        dataIndex: 'days',
        render: (text, record) => {
          let currentDate = moment()
          let timeDiff = currentDate.diff(record.createdByUser.time, 'days')
          return (
            <div>
              {/* <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div> */}
              <div>{timeDiff ? timeDiff : ""}</div>
            </div>
          )
        }
      },
      {
        title: 'Title',
        key: 'title',
        searchTextName: 'title',
        filterRegex: true
      },
      {
        title: 'Description',
        key: 'description',
        searchTextName: 'description',
        filterRegex: true,
        render: (text, record) => (
          <Button onClick={() => this.showDescription(record)}>Show Detail</Button>
        )
      },
      {
        title: 'Related To',
        key: 'relatedTo',
        filters: [{ value: "LMS", text: "LMS" }, { value: "T-Vision", text: "T-Vision" }, { value: "T-Connect", text: "T-Connect" }],
        filterRegex: true
      },
      {
        title: 'Token',
        key: 'suggestionToken',
        searchTextName: 'suggestionToken',
        filterRegex: true
      },
      {
        title: 'Type',
        key: 'suggestionType',
        filters: [{ value: "Only Suggestion", text: "Only Suggestion" }, { value: "Raise Ticket", text: "Raise Ticket" }],
        filterRegex: true,
        render: (text, record) => (
          <React.Fragment>
            {
              record.suggestionType == 'Only Suggestion' ?
                <>
                  <p><b>Type: </b>{record.suggestionType}</p>
                  <p><b>Status: </b>{record.suggestionStatus}</p>
                </>
                :
                <>
                  <p><b>Type: </b>{record.suggestionType}</p>
                  <p><b>Status: </b>{record.suggestionStatus}</p>
                </>
            }
          </React.Fragment>
        )
      },
      {
        title: 'Added By',
        key: 'createdByUser.name',
        dataIndex: 'createdByUser.name',
        filters: this.state.users,
        filterRegex: true,
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'staffSuggestions.edit'}>
              <Tooltip title="Edit Suggestion">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setSuggestionData(record)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <Tooltip title="Update Status">
              <Button
                className={styles.btn}
                shape="circle"
                onClick={() => {
                  this.updateSuggestionStatusDrawer(record._id)
                }}
                icon="forward"
              />
            </Tooltip>
            <RightsWrapper myRight={'staffSuggestions.delete'}>
              <Tooltip title="Delete Suggestion">
                <Popconfirm
                  title="Are you sure delete this?"
                  onConfirm={() => {
                    this.deleteSuggestion({ _id: record._id })
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <>
        <PageHeaderWrapper title={` Suggestions /  Tickets `}>
          {
            showUpdateStatusDrawer ?
              <UpdateSuggestionStatus suggestionId={suggestionId} onClose={this.closeUpdateDrawer} />
              : null
          }
          {
            showAddSuggestionDrawer ?
              <AddEditSuggestion record={record} onClose={this.closeAddSuggestion} />
              : null
          }
          <Card bordered={true}>
            <Row>
              <Col span={20}></Col>
              <Col span={4}>
                <Button type='primary' onClick={this.showAddSuggestion}>Add Suggestion/Ticket</Button>
              </Col>
            </Row>
            <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
              <TabPane tab={`Pending`} key={0}>
                <h2>{`Total : ${this.state.total}`}
                </h2>

                <TableComp
                  ref={this.table}
                  columns={columns}
                  apiRequest={this.apiRequest}
                  extraProps={{ scroll: { x: 900 } }}
                  pagination={{
                    showSizeChanger: true,
                    defaultPageSize: 50,
                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                  }}
                />
              </TabPane>
              <TabPane tab={`In Process`} key={1}>
                <h2>{`Total : ${this.state.total}`}</h2>
                <TableComp
                  ref={this.table}
                  columns={columns}
                  apiRequest={this.apiRequest}
                  extraProps={{ scroll: { x: 900 } }}
                  pagination={{
                    showSizeChanger: true,
                    defaultPageSize: 50,
                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                  }}
                />
              </TabPane>
              <TabPane tab={`Under Testing`} key={2}>
                <h2>{`Total : ${this.state.total}`}</h2>
                <TableComp
                  ref={this.table}
                  columns={columns}
                  apiRequest={this.apiRequest}
                  extraProps={{ scroll: { x: 900 } }}
                  pagination={{
                    showSizeChanger: true,
                    defaultPageSize: 50,
                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                  }}
                />
              </TabPane>
              <TabPane tab={`Completed`} key={3}>
                <h2>{`Total : ${this.state.total}`}</h2>
                <TableComp
                  ref={this.table}
                  columns={columns}
                  apiRequest={this.apiRequest}
                  extraProps={{ scroll: { x: 900 } }}
                  pagination={{
                    showSizeChanger: true,
                    defaultPageSize: 50,
                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                  }}
                />
              </TabPane>
            </Tabs>
          </Card>
        </PageHeaderWrapper>
        {
          modalOpen ?
            <Modal title={record.title} visible={modalOpen} onOk={this.handleOk} onCancel={this.handleCancel} footer={[
              <Button type='primary'>Added By :- {record.createdByUser.name}</Button>
            ]}>
              <p>{record.description}</p>
              {record.document && record.document.length ?
                <Button type='primary' href={`${MEDIA_URL}${record.document[0].url}`}>Download Attachment</Button>
                : null}
            </Modal>

            : null
        }
      </>
    );
  }
}

export default AllStaffSuggestions
